import React from 'react';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { Editor } from 'slate';
import { isArtifactEmbedElement } from '../../../types/guards';

class ToolEditArtifactEmbed extends Tool {
  static toolName = 'Create new version';

  static action({ editor, element, controller }: ToolArgsWithController): void {
    if (!controller || !element || !isArtifactEmbedElement(element)) return;

    const provider = controller.ahaEditor.getProvider('assistant');
    provider?.openGlobalAssistant({
      agentName: 'AppPrototypeAgent',
      agentParams: {
        stickyReferences: [element.embed_src ?? ''],
        projectId:
          controller.parent?.props?.projectId ||
          (window as any).currentProjectId,
      },
    });
  }

  static available({ controller, editor }: ToolArgsWithController): boolean {
    if (!controller) return false;
    if (!controller.ahaEditor.hasProvider('assistant')) return false;

    const embeds = Editor.above(editor, {
      mode: 'lowest',
      match: isArtifactEmbedElement,
    });

    if (embeds && embeds.length > 0) {
      return true;
    }

    return false;
  }

  static renderToolbarButtonIcon() {
    return (
      <span className="tw-px-1 tw-flex tw-items-center tw-gap-1">
        <aha-ai-icon size={13} />
        {this.toolName}
      </span>
    );
  }
}

export default ToolEditArtifactEmbed;
